import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Navigation } from '@/components/layout/Navigation'
import { ChatAssistant } from '@/components/chat/ChatAssistant'

export function DashboardLayout() {
  const [isChatOpen, setIsChatOpen] = useState(false)

  return (
    <div className="min-h-screen bg-cream">
      <Navigation />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>

      {/* Chat FAB Button */}
      <button
        onClick={() => setIsChatOpen(true)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-forest text-white rounded-full shadow-lg hover:bg-forest-dark transition-all hover:scale-105 flex items-center justify-center z-40"
        title="Open Budget Assistant"
      >
        <span className="text-2xl">💬</span>
      </button>

      {/* Chat Assistant */}
      <ChatAssistant isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </div>
  )
}
